module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/header.json
// module id = 545
// module chunks = 35